import { __rest } from '../../_virtual/_tslib.js';
import { createLocation } from 'history';
import { createElement } from 'react';
import { withRouter } from 'react-router-dom';
import { mapProps } from './withReactRouterLink.js';

var mapFunction = function mapFunction(location, history) {
  return function (_a) {
    var to = _a.to,
        replace = _a.replace,
        _onClick = _a.onClick,
        htmlAttrs = _a.htmlAttrs,
        children = _a.children,
        props = __rest(_a, ["to", "replace", "onClick", "htmlAttrs", "children"]);

    var locationHref = typeof to === "string" ? createLocation(to, null, null, location) : to;
    var href = locationHref ? history.createHref(locationHref) : "";
    return Object.assign(Object.assign({}, props), {
      href: href,
      htmlAttrs: htmlAttrs,
      onClick: function onClick(event) {
        var _a, _b;

        try {
          if (_onClick) _onClick(event);
        } catch (ex) {
          event.preventDefault();
          throw ex;
        }

        if (!event.defaultPrevented && // onClick prevented default
        !((_b = (_a = event === null || event === void 0 ? void 0 : event.detail) === null || _a === void 0 ? void 0 : _a.mouseEvent) === null || _b === void 0 ? void 0 : _b.button) && (!(htmlAttrs === null || htmlAttrs === void 0 ? void 0 : htmlAttrs.target) || (htmlAttrs === null || htmlAttrs === void 0 ? void 0 : htmlAttrs.target) === "_self") && // let browser handle "target=_blank" etc.
        !(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey)) {
          event.preventDefault();
          var newLocation = typeof to === "function" ? to(location) : to;
          var method = replace ? history.replace : history.push;
          method(newLocation);
        }
      },
      to: undefined,
      children: children === null || children === void 0 ? void 0 : children.map(mapFunction(location, history))
    });
  };
};

var withReactRouterNavigation = function withReactRouterNavigation(WrappedComponent) {
  var WrappedNavigation = function WrappedNavigation(_a) {
    var navigationObject = _a.navigationObject,
        navigationTree = _a.navigationTree,
        location = _a.location,
        history = _a.history,
        props = __rest(_a, ["navigationObject", "navigationTree", "location", "history"]);

    var mappedProps = props;

    if (props.to) {
      mappedProps = mapProps(location, history, "")(props);
    }

    Object.keys(props).forEach(function (p) {
      // map subcomponent router props like ("logoTo", "logoHref", "onLogoClick", "logoAttrs", etc.);
      if (p.endsWith("To")) {
        var prefix = p.slice(0, -2);
        mappedProps = mapProps(location, history, prefix)(props);
      }
    });
    return /*#__PURE__*/createElement(WrappedComponent, Object.assign({}, mappedProps, {
      navigationObject: navigationObject === null || navigationObject === void 0 ? void 0 : navigationObject.map(mapFunction(location, history)),
      navigationTree: navigationTree === null || navigationTree === void 0 ? void 0 : navigationTree.map(mapFunction(location, history))
    }));
  };

  return withRouter(WrappedNavigation);
};

export { withReactRouterNavigation };
